import React from 'react'
import ShowFrontEnd from '../components/frontend/ShowFrontEnd'

const FirstPage: React.FC = () => {
  return (
    <ShowFrontEnd/>
  )
}

export default FirstPage